import apiService from '../services/apiService';
import Employee from '../models/Employee';

export const employeeController = {
  getAll: async (filters = {}) => {
    try {
      const queryParams = new URLSearchParams(filters).toString();
      const endpoint = queryParams ? 'employees?${queryParams}' : 'employees';
      const response = await apiService.get(endpoint);
      const items = response.data?.map(item => Employee.fromJSON(item)) || [];
      return { success: true, data: items, total: response.total || items.length };
    } catch (error) {
      return { success: false, data: [], message: error.message || 'Failed to fetch employees' };
    }
  },

  getById: async (id) => {
    try {
      const response = await apiService.get(`employees/${id}`);
      return { success: true, data: Employee.fromJSON(response.data) };
    } catch (error) {
      return { success: false, data: null, message: error.message };
    }
  },

  create: async (data) => {
    try {
      const item = new Employee(data);
      const validation = item.validate();
      if (!validation.isValid) return { success: false, errors: validation.errors };
      const response = await apiService.post('employees', item.toJSON());
      return { success: true, data: Employee.fromJSON(response.data), message: 'Employee created successfully' };
    } catch (error) {
      return { success: false, message: error.message };
    }
  },

  update: async (id, data) => {
    try {
      const item = new Employee({ ...data, id });
      const validation = item.validate();
      if (!validation.isValid) return { success: false, errors: validation.errors };
      const response = await apiService.put(`employees/${id}`, item.toJSON());
      return { success: true, data: Employee.fromJSON(response.data), message: 'Employee updated successfully' };
    } catch (error) {
      return { success: false, message: error.message };
    }
  },

  delete: async (id) => {
    try {
      await apiService.delete(`employees/${id}`);
      return { success: true, message: 'Employee deleted successfully' };
    } catch (error) {
      return { success: false, message: error.message };
    }
  },

  export: async (filters = {}, format = 'csv') => {
    try {
      const queryParams = new URLSearchParams({ ...filters, format }).toString();
      const response = await apiService.get(`employees/export?${queryParams}`);
      return { success: true, data: response.data };
    } catch (error) {
      return { success: false, message: error.message };
    }
  },

  getStatistics: async (filters = {}) => {
    try {
      const queryParams = new URLSearchParams(filters).toString();
      const endpoint = queryParams ? `employees/statistics?${queryParams}` : 'employees/statistics';
      const response = await apiService.get(endpoint);
      return { success: true, data: response.data };
    } catch (error) {
      return { success: false, data: null, message: error.message };
    }
  }
};

export default employeeController;